module.exports = __webpack_public_path__ + "img/icon-speed-1.ab1449cf.svg";